import { render, staticRenderFns } from "./creditiDistributori.vue?vue&type=template&id=2812cf96&"
import script from "./creditiDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./creditiDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports